"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var MagicWandSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M14.4552307,14.4358909 C13.7076838,15.1834378 12.4701202,15.1834378 11.7225733,14.4358909 L6.14644671,8.85355339 C5.95135902,8.65826137 5.95144184,8.3418216 6.14663172,8.14663172 L8.1462616,6.1462616 C8.34152374,5.95099945 8.65810623,5.95099945 8.85336838,6.1462616 L14.4296801,11.7287842 C15.177227,12.4763311 15.2027776,13.688344 14.4552307,14.4358909 Z M8.5,7.20710678 L7.20710678,8.483 L12.4296801,13.7287842 C12.7867027,14.0858068 13.3655507,14.0858068 13.7225733,13.7287842 C14.0795959,13.3717616 14.0795959,12.7929135 13.7225733,12.4358909 L8.5,7.20710678 Z M8,3 L9,3 L9,5 L8,5 L8,3 Z M3,8 L5,8 L5,9 L3,9 L3,8 Z M4.15053497,4.84276006 C3.95820598,4.64974046 3.95851596,4.33743037 4.15122773,4.14479293 C4.34389692,3.95219806 4.65617452,3.95212656 4.84893189,4.14463318 L5.86558569,5.15996451 C6.05869225,5.35281988 6.05889589,5.66570384 5.86604052,5.8588104 C5.67020234,6.05337214 5.35602107,6.05257482 5.16254245,5.85840146 L4.15053497,4.84276006 Z M11.1538841,5.85733345 C10.9611466,5.66585748 10.9601239,5.35439093 11.1515999,5.16165344 L11.1545487,5.15871024 L12.170724,4.15302048 C12.3646088,3.96113626 12.6770806,3.96191636 12.8700049,4.15476627 C13.0620621,4.34674939 13.0621222,4.65807557 12.8701391,4.85013277 L11.8575953,5.85714279 C11.6629813,6.05069266 11.348603,6.05077784 11.1538841,5.85733345 Z" })));
};
MagicWandSmall.displayName = 'MagicWandSmall';
exports.default = MagicWandSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=MagicWandSmall.js.map